import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { Switch as SwitchPrimitive } from 'radix-ui';

import { cn } from '../../lib/utils';

const switchVariants = cva('', {
  variants: {
    size: {
      default: 'h-6 w-11',
      sm: 'h-5 w-[34px]',
    },
  },
  defaultVariants: { size: 'default' },
});

const thumbVariants = cva('', {
  variants: {
    size: {
      default: 'data-[state=checked]:translate-x-6',
      sm: 'shadow-sm data-[state=checked]:translate-x-3.5',
    },
  },
  defaultVariants: { size: 'default' },
});

function Switch({
  className,
  size,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & VariantProps<typeof switchVariants>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-muted-foreground focus-visible:border-ring focus-visible:ring-ring inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        switchVariants({ size }),
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'bg-background dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=unchecked]:translate-x-0',
          thumbVariants({ size }),
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
